
import {DecimalConfig} from "@/models/dossier-configs/decimal-config";
import {Product, Sale} from "@/models/base";
import {DossierConfigService} from "@/services/dossier-config-service";
import {ProductRow, ProductTotal} from "@/utils/product-row";
import Vue from "vue";
import {UserConfigService} from "../../services/user-config-service";
import {StockLocationConfig} from "@/models/dossier-configs/stock-location";
import {ProductEditRowState} from "@/utils/products-table/product-edit-row-state";
import {RecoverySale} from "@/models/base/recovery-sale";
import {SaleEditRowExtraInfoField} from "@/utils/sale-edit/sale-edit-row-extra-info-field";
import { printHumanFloat, printHumanFloatPercentage } from "@/utils/pretty-print";

export default Vue.extend({
	data(){
		return {
			recoverySale: null as null | RecoverySale,
			userSaleSettings: UserConfigService.getSaleSettings()
		};
	},
	props: {
		selectedRow: Object as () => ProductRow,
		editRow: Object as () => ProductEditRowState,
		totalable: {
			type: Object as () => Sale,
			required: true
		},
		product: Object as () => Product,
		toggleProfit: Boolean,
		toggleStockInfo: Boolean,
	},
	computed: {
		selectedProfitLine():string {
			let num = printHumanFloat(this.selectedProfit, this.decimalSettings.Buy);
			return `${num} (${printHumanFloatPercentage(this.selectedProfitPercentage, 1)})`;
		},
		totalProfitLine():string {
			let num =  printHumanFloat(this.totalProfit, this.decimalSettings.Unit);
			return `${num} (${printHumanFloatPercentage(this.totalProfitPercentage, 1)})`;
		},
		stockLocationConfig(): StockLocationConfig {
			return DossierConfigService.getStockLocationConfig();
		},
		ExtraInfoFields():SaleEditRowExtraInfoField[]{
			return UserConfigService.getSaleSettings().SaleEditRowExtraInfoFields;
		},
		stockInfo(): string {

			let p = [] as any;
			if(this.editRow?.product){
				p = this.ExtraInfoFields.map((f) => {
					if(this.editRow.product){
						return (f.Label+ (f.Label ? ": " : "") + (this.getValue(f.Field)) as any || "");
					}
				});
			}

			if(this.userSaleSettings.ShowSeperateStockInfo){

				let i = this.stockLocationConfig.getSortedLocationNames().map((l: string, i: number) => {
					return {
						text: l,
						value: i + 1,
						stock: this.getStock(i+1)
					} as any;
				});

				let y = i.filter((c) => c.stock != 0).map((c) => {
					return c.text +": "+c.stock;
				});

				return p.join(" | ") + (p.length ? " | " : "") + y.join(" | ");

			}
			return p.join(" | ") + (p.length ? " | " : "") ;
		},
		shouldShowRecovery(): Boolean {
			if(!this.recoverySale){
				return false;
			}
			return this.recoverySale?.ID > 0;
		},
		shouldShowProfit(): Boolean {
			if (!UserConfigService.hasCurrentUserPermission(p => p.CanReadProductPurchaseDetails)) {
				return false;
			}
			return this.toggleProfit;
		},
		shouldShowStockInfo(): Boolean {
			if (!UserConfigService.hasCurrentUserPermission(p => p.StockPermissions.CanRead)) {
				return false;
			}
			return this.toggleStockInfo;
		},
		item(): ProductTotal {
			return this.totalable.getProductTotals();
		},
		totalNetto(): number {
			return this.item.TotalExcVAT / this.totalable.CurrencyRate;
		},
		vat(): number {
			return this.item.TotalVAT / this.totalable.CurrencyRate;
		},
		total(): number {
			return this.totalable.TotalToPay / this.totalable.CurrencyRate;
		},
		totalLeeggoed(): number {
			return this.item.TotalLeeggoed;
		},
		selectedUnitBuyPrice(): number {
			if (!this.selectedRow) return 0;
			return this.selectedRow.UnitBuyPrice || 0;
		},
		selectedStock(): number {
			if (!this.selectedRow?.Product) return 0;
			return this.selectedRow.Product.Stock?.Location1Qty || 0;
		},
		selectedProfit(): number {
			if (!this.selectedRow) return 0;
			let totalLoss = this.selectedUnitBuyPrice * this.selectedRow.Amount;
			let totalWithoutDiscount = (this.editRow?.netto) /*+ (this.selectedRow.Amount * this.editRow?.accijnzenTax)*/;
			let total = totalWithoutDiscount; /*- (totalWithoutDiscount * (this.selectedRow.Discount / 100));*/
			return total - totalLoss;
		},
		selectedProfitPercentage():number {
			if (!this.selectedRow) return 0;
			let total = this.selectedUnitBuyPrice * this.selectedRow.Amount;
			if (total == 0) return 0;
			let percentage = this.selectedProfit / total;
			return percentage * 100;
		},
		totalProfit(): number {
			/*let total = 0;
			for (let row of this.item.rows) {
				let amount = row.Amount;
				let loss = (row.UnitBuyPrice || 0) * amount;
				let totalSellPriceWithoutDiscount = amount * row.UnitPrice;
				let totalDiscount = totalSellPriceWithoutDiscount * (row.Discount / 100);
				let totalSellPrice = totalSellPriceWithoutDiscount - totalDiscount;
				total += totalSellPrice - loss;
			}
			*/
			return this.totalable.getProfit();
		},
		totalProfitPercentage():number{
			return (this.totalProfit / (this.totalable.TotalExcVAT-this.totalProfit)) * 100.0;
		},
		decimalSettings(): DecimalConfig {
			return DossierConfigService.getDecimalSettings();
		}
	},
	methods: {
		getStock(location:number) {
			if (!this.editRow?.product?.Stock) return 0;
			let t = this.editRow.product.Stock as any;
			return t["Location"+location+"Qty"];
		},
		getValue(propertyString: string) {
			let properties = propertyString.split("."); // Split the string into an array of property names
			let value = this.editRow.product as any;
			for (var i = 0; i < properties.length; i++) {
				if(value){
					value = value[properties[i] as keyof Product];
				}
			}
			return value;
		}
	},
	i18nEx: {
		componentPrefix: "components.products-table"
	}
});
